import React from 'react'
import BackgroundImage from './3.svg'
import './index.scss'

class Masthead extends React.Component {
    constructor(props) {
        super(props)
    }
    // handleMouseMove(event) {
    //     var x = event.clientX;
    //     var rect = this.node.getBoundingClientRect()        
    //     var y = event.clientY - 100 + this.state.scrollTop; // 100 is height of header
    //     var mouseX = Math.round(x / this.state.width * 100 * 100) / 100;
    //     var mouseY = Math.round(y / this.state.height * 100 * 100) / 100;
        
    //     this.setState({
    //       styles: {
    //         backgroundImage: `radial-gradient(circle at ${mouseX}% ${mouseY}%, #3498db, #1276b9)`,
    //       },
    //     })
    // }

    // componentDidMount() {
    //     var rect = this.node.getBoundingClientRect();
    //     this.setState({
    //       width: Math.round(rect.width, 0),
    //       height: Math.round(rect.height, 0),
    //     })
    // }

    // handleMouseEnter(event) {
    //     var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop();
    //     this.setState({
    //         scrollTop: scrollTop
    //     })        
    // }

    render() {
        return <div className="masthead">
            <div className="masthead__wrapper">
              <div className="masthead__content">
                <main>
                  <p>Hello,</p>
                  <p>My name is <strong>Besart Bytyqi</strong>. I made this site to showcase things I can do and have done. There isn't much here yet but I just needed to put something up. I felt like if I didn't put at least something up, I shouldn't start working on anything else.</p>
                  <p>The logos below are some of the tools/services I've used in the past or use now. If you have a mouse, you can hover over them for a cool hover effect that took me way too long to code. If you don't have a mouse, trust me, it's cool. This website is made using Gatsby JS. I've never worked with Gatsby before and I also have never really done anything meaningful in React. I'm using this website as a good way for me to learn a little bit about React.</p>
                </main>
              </div>
            </div>
          </div>
    }
}
export default Masthead



// WEBPACK FOOTER //
// ./src/components/Masthead/index.js